import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        get_config: {
            parameters: []
        },
        set_state: {
            parameters: [
                {
                    name: 'key',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'state',
                    type: ['string', 'object'],
                    optional: false
                }
            ]
        },
        get_state: {
            parameters: [
                {
                    name: 'key',
                    type: 'string',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
